import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Tooltip } from '@material-ui/core';
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import AddNew from "./AddNew";
import CreateCountry from "./CreateCountry";
import CreateState from "./CreateState";
import CreateCurrency from "./CreateCurrency";
import CreateEmailTemp from "./CreateEmailTemp";
import CreateCompany from "./CreateCompany";
import TreeView from "./TreeView";
import CreateBank from "./CreateBank";
import CreateUserGroup from "./CreateUserGroup";
import CreateStore from "./CreateStore";

let MaxWidth = 'xs';

const PrimaryMaster = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Name, setName] = useState('Country');
  const [TypeName, setTypeName] = useState('');
  const [PKID, setPKID] = useState('');
  const [Count, setCount] = useState();
  const [isOpen, setOpen] = useState(false);
  const [response, fetchData] = UseFetchData();

  const handleOpenModal = () => {
    setPKID('');
    setOpen(true);
  }

  const openModal = (row) => {
    setPKID(row);
    setOpen(true);
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("Type", Name);
    bodyFormData.append("SearchString", TypeName);
    fetchData("Primary/List", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (response.length === 0) {
      setRows([]);
      setCount(0);
    }
    if (response.length > 0) {
      setRows(response);
      setCount(response.length);
    }
  }, [response])

  const returnModal = () => {
    if (Name === "Company") {
      MaxWidth = 'xs';
      return (
        <CreateCompany Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Country") {
      MaxWidth = 'xs';
      return (
        <CreateCountry Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "State") {
      MaxWidth = 'xs';
      return (
        <CreateState Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Currency") {
      MaxWidth = 'xs';
      return (
        <CreateCurrency Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "EmailTemplate") {
      MaxWidth = 'md';
      return (
        <CreateEmailTemp Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }

    else if (Name === "BankMaster") {
      MaxWidth = 'xs';
      return (
        <CreateBank Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "UserGroup") {
      MaxWidth = 'xs';
      return (
        <CreateUserGroup Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Store") {
      MaxWidth = 'xs';
      return (
        <CreateStore Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else {
      MaxWidth = 'xs';
      return (
        <AddNew Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: Name,
        headerName: Name + " Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
      },
    ];
    const copygridclm = gridCols.slice();
    if (Name === "Country") {
      const clm = {
        field: "CountryISO",
        headerName: "Country ISO",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      copygridclm.push(clm);
    }
    else if (Name === "State") {
      const clm = {
        field: "StateCode",
        headerName: "State Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "Country",
        headerName: "Country",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      copygridclm.push(clm);
      copygridclm.push(clm2);
    }
    else if (Name === "Currency") {
      const clm = {
        field: "CurrencySymbol",
        headerName: "Currency Symbol",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      const clm2 = {
        field: "ConversionRate",
        headerName: "Conversion Rate",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      copygridclm.push(clm);
      copygridclm.push(clm2);
    }
    else if (Name === "EmailTemplate") {
      const clm = {
        field: "Subject",
        headerName: "Subject",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      const clm2 = {
        field: "EmailBody",
        headerName: "Email Body",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        renderCell: (params) => (
          <Tooltip title={params.row.EmailBody} >
            <span className="table-cell-trucate">{params.row.EmailBody}</span>
          </Tooltip>
        ),
      }
      copygridclm.push(clm);
      copygridclm.push(clm2);
    }
    else if (Name === "Company") {

      const clm1 = {
        field: "CompanyCode",
        headerName: "Company Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "Website",
        headerName: "Website",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm3 = {
        field: "EmailID",
        headerName: "EmailID",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm4 = {
        field: "GSTIN",
        headerName: "GSTIN",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm5 = {
        field: "PAN",
        headerName: "PAN",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm6 = {
        field: "Address",
        headerName: "Company Add",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      copygridclm.push(clm1);
      copygridclm.push(clm2);
      copygridclm.push(clm3);
      copygridclm.push(clm4);
      copygridclm.push(clm5);
      copygridclm.push(clm6);
    }
    else if (Name === "Store") {
      const clm1 = {
        field: "StoreCode",
        headerName: "Store Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      copygridclm.push(clm1);
    }
    else if (Name === "BankMaster") {
      const clm1 = {
        field: "AccountNo",
        headerName: "BankAccountNo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "CompanyName",
        headerName: "Company",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 280,
      };
      const clm3 = {
        field: "Address",
        headerName: "Address",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm4 = {
        field: "Currency",
        headerName: "Currency",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      };
      const clm5 = {
        field: "IFSCCode",
        headerName: "IFSC Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      };
      // const clm6 = {
      //   field: "IntermediaryBankName",
      //   headerName: "INTERMEDIARY BANK NAME",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // };
      const clm7 = {
        field: "SwiftCode",
        headerName: "Swift Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      };
      const clm8 = {
        field: "IntermediaryBankAddress",
        headerName: "Bank PhysicalAdd",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      copygridclm.push(clm1);
      copygridclm.push(clm2);
      copygridclm.push(clm3);
      copygridclm.push(clm4);
      copygridclm.push(clm5);
      // copygridclm.push(clm6);
      copygridclm.push(clm7);
      copygridclm.push(clm8);

    }
    if (Name === "UserGroup") {
      const clm = {
        field: "AccountGroup",
        headerName: "Account Group",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      copygridclm.push(clm);
    }
    setColumns(copygridclm);
    PopulateData()
  }, [Name]);

  return (
    <div>
      <table style={{ width: "100%", marginTop: "1%" }}>
        <tbody>
          <tr>
            <td style={{ width: "13%", border: "0.1rem solid gray", verticalAlign: 'top' }}>
              <TreeView setName={setName} />
            </td>
            <td>
              <table style={{ width: "100%", marginTop: -9 }}>
                <tbody>
                  <tr>
                    <td>
                      <h1>{Name}</h1>
                    </td>
                  </tr>
                  <tr>
                    <BiztranControls.Input
                      label={Name + " Name"}
                      id={Name}
                      onChange={(e) => setTypeName(e.target.value)}
                    />
                    <BiztranControls.Button
                      text="SEARCH"
                      startIcon={<SearchIcon />}
                      onClick={() => {
                        PopulateData();
                      }}
                    />
                    <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                    <BiztranControls.Button
                      text="ADD NEW"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={() => {
                        handleOpenModal();
                      }}
                    />
                    <ModalFrame
                      title={Name + " Details"}
                      maxWidth={MaxWidth}
                      isOpen={isOpen}
                      setOpen={setOpen}
                    >
                      {returnModal()}
                    </ModalFrame>
                  </tr>
                  <tr>
                    <td>
                      <BiztranControls.DataGrid
                        rowHeight={25}
                        headerHeight={34}
                        header
                        rows={rows}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooterPagination={true}
                        hideFooter={true}
                        Height="555px"
                        Width="100%"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrimaryMaster;
